import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { PageTitle } from 'pricing-pages-ui-components/semantic/PageHeader';
import { memo } from 'react';
import { COMMERCE } from 'self-service-api/constants/EnrolledProductLines';
import { CMS, MARKETING, OPERATIONS, SALES, SERVICE } from 'self-service-api/constants/ProductLines';
import { NavItemEnum } from '../../constants/routing/NavItems';
import { useAppSelector } from '../../reducers';
import { isUngatedForInbound25Selector } from '../../selectors/GatingSelectors';
import ProductIcon from './ProductIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ProductPageTitle = ({
  productLine,
  nonProductIdentifier
}) => {
  if (nonProductIdentifier === NavItemEnum.COMMERCE) {
    productLine = COMMERCE;
  }
  const tradeMarkMap = {
    [MARKETING]: {
      includeRegisteredTrademark: true
    },
    [SALES]: {
      includeRegisteredTrademark: true
    },
    [SERVICE]: {
      includeRegisteredTrademark: true
    },
    [CMS]: {
      includeTrademark: true
    },
    [OPERATIONS]: {
      includeRegisteredTrademark: true
    },
    [COMMERCE]: {
      includeTrademark: true
    }
  };
  const isUngatedForInbound = useAppSelector(isUngatedForInbound25Selector);
  const translationKeyMap = {
    [MARKETING]: 'pricingPage.pages.products.tabs.marketing.pageTitle',
    [SALES]: 'pricingPage.pages.products.tabs.sales.pageTitle',
    [SERVICE]: 'pricingPage.pages.products.tabs.service.pageTitle',
    [CMS]: 'pricingPage.pages.products.tabs.cms.pageTitle',
    [OPERATIONS]: isUngatedForInbound ? 'pricingPage.pages.products.tabs.data.pageTitle' : 'pricingPage.pages.products.tabs.operations.pageTitle',
    [COMMERCE]: 'pricingPage.pages.products.tabs.commerce.pageTitle',
    [NavItemEnum.SMART_CRM]: 'pricingPage.pages.products.tabs.smart-crm.pageTitle',
    [NavItemEnum.BUNDLE]: 'pricingPage.pages.products.tabs.bundle.pageTitle',
    [NavItemEnum.FREE]: 'pricingPage.pages.products.tabs.crm.pageTitle',
    [NavItemEnum.SUITE]: 'pricingPage.pages.products.tabs.suite.pageTitle',
    [NavItemEnum.MARKETING_PLUS]: 'pricingPage.pages.products.tabs.marketing-plus.pageTitle',
    [NavItemEnum.BREEZE_INTELLIGENCE]: 'pricingPage.pages.products.tabs.breeze-intelligence.pageTitle',
    [NavItemEnum.HUBSPOT_CREDITS]: 'pricingPage.pages.products.tabs.hubspot-credits.pageTitle'
  };
  return /*#__PURE__*/_jsxs(PageTitle, {
    "aria-level": 1,
    children: [/*#__PURE__*/_jsx(ProductIcon, {
      name: productLine || nonProductIdentifier,
      iconStyle: {
        marginInlineEnd: '300',
        blockSize: '32px',
        inlineSize: '32px'
      }
    }), productLine && translationKeyMap[productLine] && /*#__PURE__*/_jsx(FormattedMessage, {
      message: translationKeyMap[productLine]
    }), nonProductIdentifier && translationKeyMap[nonProductIdentifier] && /*#__PURE__*/_jsx(FormattedMessage, {
      message: translationKeyMap[nonProductIdentifier]
    }), productLine && tradeMarkMap[productLine].includeTrademark && /*#__PURE__*/_jsx(Text, {
      as: "span",
      typography: "heading-400",
      children: "\u2122"
    }), productLine && tradeMarkMap[productLine].includeRegisteredTrademark && /*#__PURE__*/_jsx(Text, {
      as: "span",
      typography: "heading-400",
      children: "\xAE"
    })]
  });
};
export default /*#__PURE__*/memo(ProductPageTitle);